import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-1 text-sm"
}
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = {
  key: 2,
  class: "flex items-center gap-2 text-sm"
}

type FieldRow = 'text' | 'pair' | 'textarea' | 'checkbox'


export default /*@__PURE__*/_defineComponent({
  __name: 'SkeletonForm',
  props: {
    fields: {},
    widthClass: { default: 'max-w-lg' }
  },
  setup(__props: any) {

/**
 * Placeholder form matching the admin form field markup (`text-sm` label
 * over a `bg-accent px-3 py-2` control), so a loading edit page occupies
 * exactly the same space as the form that replaces it.
 *
 * - `text`: single full-width field
 * - `pair`: two fields in the responsive two-column grid
 * - `textarea`: three-line control
 * - `checkbox`: checkbox + label row
 */


return (_ctx: any,_cache: any) => {
  const _component_AdminSkeleton = _resolveComponent("AdminSkeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col gap-4", __props.widthClass]),
    "aria-hidden": "true"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (field === 'text' || field === 'pair')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(field === 'pair' ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : '')
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((field === 'pair' ? 2 : 1), (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: n,
                  class: "flex flex-col gap-1 text-sm"
                }, [
                  _createElementVNode("span", _hoisted_1, [
                    _createVNode(_component_AdminSkeleton, { class: "bg-accent w-24" })
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg-accent px-3 py-2 animate-pulse" }, [
                    _createElementVNode("span", { class: "invisible" }, " ")
                  ], -1))
                ]))
              }), 128))
            ], 2))
          : (field === 'textarea')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_AdminSkeleton, { class: "bg-accent w-24" })
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg-accent px-3 py-2 animate-pulse" }, [
                  _createElementVNode("span", { class: "invisible block" }, " "),
                  _createElementVNode("span", { class: "invisible block" }, " "),
                  _createElementVNode("span", { class: "invisible block" }, " ")
                ], -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "inline-block h-3.5 w-3.5 bg-accent animate-pulse" }, null, -1)),
                _createVNode(_component_AdminSkeleton, { class: "bg-accent w-40" })
              ]))
      ], 64))
    }), 128)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex gap-3" }, [
      _createElementVNode("div", { class: "bg-accent px-4 py-2 animate-pulse" }, [
        _createElementVNode("span", { class: "invisible" }, "Save")
      ])
    ], -1))
  ], 2))
}
}

})